import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import { TableIcon } from "lucide-react";
import { useAnpHistoricalReports } from "../../hooks/useAnpHistoricalReports";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { AnpHistoricalReportsTransformer } from "../../services/anpHistoricalReportsTransformer";
import { anpReportsDefaultColumns } from "../../constants/anpReportsDefaultColumns.constant";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";

const AnpHistoricalReportsList = () => {
  const { filterParams, setFilterParams } = useFilterParams();
 
  const {
    data: anpReports,
    meta,
    isLoading: anpReportsIsLoading,
    error: anpReportsError = {} as any,
    refetch: refetchAnpReports,
  } = useAnpHistoricalReports({
    filters: { page: filterParams.page || 1 },
    mapper: Mapper.mapWithTransformer({ transformer: AnpHistoricalReportsTransformer.tableTransformer() }),
  });

  return (
    <div className="flex flex-col gap-6">
      <ListHeader
        Icon={<TableIcon className="w-10 h-10" strokeWidth={1} />}
        title="Tabelas Série Historica Mensal ANP"
      />

      <ErrorMessageWrapper
        className="max-h-[calc(100vh-128px)]"
        statusCode={anpReportsError?.status}
        refetchFunction={refetchAnpReports}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
          <Table
            columns={anpReportsDefaultColumns}
            isLoadingData={anpReportsIsLoading}
            page={Number(filterParams.page) || 1}
            rows={anpReports}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
            rowEmptyValue="--"
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  );
};

export default AnpHistoricalReportsList;
